define('app/views/location',['require','./baseview','./page'],function(require){

  var BaseView = require('./baseview');
  var Page = require('./page');

  return Page.extend({

    view: 'location',

    afterRender: function(){
      var mapInstance = this.$el.find('#google-map').data().instance;

      mapInstance.on(BaseView.AFTER_LOADED, function(){
        mapInstance.cleanMarkers();

        var priveMarker = {
          map: mapInstance.map,
          position: new google.maps.LatLng(40.7614757,-73.981282),
          icon: '/images/map-pin-prive.png'
        };

        new google.maps.Marker(priveMarker);

        var lebernardinMarker = {
          map: mapInstance.map,
          position: new google.maps.LatLng(40.7615477,-73.9817867),
          icon: {
            anchor: new google.maps.Point(65, 0),
            url: '/images/map-pin-lebernardin.png'
          },
        };

        new google.maps.Marker(lebernardinMarker);
      });
    }

  });

});
